/**
 * Sales contact — for the one plan that genuinely is sold by talking to a
 * person. FaceWise Enterprise means an institution on the invoice,
 * sublicences, a negotiated price and a signed data-processing agreement, and
 * none of that is something a checkout can settle.
 *
 * This is deliberately no longer where an upgrade goes. FaceWise and FaceWise
 * Pro carry a published price, so the honest answer to "how do I get more" is
 * the plans screen at `/plans`, which reads the live catalogue from
 * `GET /api/billing/plans/`. Send anybody who wants more of the product there;
 * keep this link for the conversation that has to be had.
 *
 * The plans screen prefers the `sales_email` the API hands back — that is the
 * address to change when sales moves. This constant is the copy baked into the
 * bundle, for anything that needs to write to us without loading the
 * catalogue first.
 */
export const SALES_MAILTO =
  'mailto:pawel.uhma@affexy.com?subject=FaceWise%20Enterprise'

/**
 * Support contact — the address the terms of service (§11.4) promise the user
 * can write to. That promise was kept only on paper: until now the running
 * application showed sales addresses and nothing else, so a customer with a
 * problem had to go back to the terms to find out where to ask for help.
 *
 * Deliberately a different address from `SALES_MAILTO`. Somebody whose
 * recording will not process is not a lead, and routing them into the sales
 * inbox is how support requests get lost.
 *
 * Overridable at build time with `VITE_SUPPORT_EMAIL`, so a change of inbox
 * does not need a code change.
 */
export const SUPPORT_EMAIL =
  import.meta.env.VITE_SUPPORT_EMAIL || 'kontakt@affexy.com'

/** `mailto:` for the support inbox, with the subject line pre-filled. */
export function supportMailto(subject: string): string {
  return `mailto:${SUPPORT_EMAIL}?subject=${encodeURIComponent(subject)}`
}
